import { createConfirmation } from 'react-confirm'
import ForeColorDialog from '../components/Dialog/ForeColorDialog'

const foreColorDialog = createConfirmation(ForeColorDialog)

export default function (confirmation, options = {}) {

  if (typeof confirmation !== 'string') {

    options = {
      modal: {
        ...confirmation.data,
      }
    }
    confirmation = ''

  }

  return foreColorDialog({ confirmation, options })

}
